export function hasUsableVehicle(vehicles) {
  return (vehicles ?? []).some(
    (v) => !v.inactive && v.complete !== false
  );
}

export function hasActiveItem(items) {
  return (items ?? []).some((item) => !item?.inactive);
}

export function getIncompleteProfileDetails(profile, requiredFields) {
  const list = requiredFields?.list ?? [];

  return {
    Birthday: {
      data: profile?.birthday,
      required: list[1]?.required,
    },
    Address: {
      data: hasActiveItem(profile?.addresses),
      required: list[4]?.required,
    },
    "Email Address": {
      data: hasActiveItem(profile?.emailAddresses),
      required: true,
    },
    Phones: {
      data: hasActiveItem(profile?.phones),
      required: list[3]?.required,
    },
    Vehicles: {
      data: hasUsableVehicle(profile?.vehicles),
      required: true,
    },
    "Driver License": {
      data: Object.keys(profile?.driversLicense || {}).length > 0,
      required: list[2]?.required,
    },
  };
}

export function shouldShowProfileIncompleteForm(profile, requiredFields) {
  if (!requiredFields?.list?.length) {
    return false;
  }

  const details = getIncompleteProfileDetails(profile, requiredFields);
  const hasMissingRequired = Object.values(details).some(
    (field) => field.required && !field.data
  );

  const genderMissing =
    requiredFields.list[0]?.required &&
    profile?.addresses?.gender === "";

  return hasMissingRequired || genderMissing;
}

export function isProfileFullyCompleteForPermits(profile) {
  return !!(
    profile?.birthday &&
    hasActiveItem(profile?.addresses) &&
    hasActiveItem(profile?.emailAddresses) &&
    hasActiveItem(profile?.phones) &&
    hasUsableVehicle(profile?.vehicles) &&
    Object.keys(profile?.driversLicense || {}).length > 0
  );
}
